import React, { useMemo } from 'react';
import { HeyYabbleCountStepTableRowPipelinesStyle as S } from './HeyYabbleCountStepTableRowPipelines.style';
import { useHeyYabbleCountStepBLoC } from '../../../../HeyYabbleCountStep.bloc';
import { useObservableState } from 'observable-hooks';
import { Text } from 'components/Text/Text';
import { PTooltip } from 'components/prime/PTooltip/PTooltip';

export const HeyYabbleCountStepTableRowPipelines: React.FC<{
  idCol: number;
  recommendedPipelineId?: number | null;
  isChecked: boolean;
}> = ({ idCol, recommendedPipelineId, isChecked }) => {
  const { $pipelines, handleChangePipelineId } = useHeyYabbleCountStepBLoC();
  const pipelines = useObservableState($pipelines, []);
  const isDisabled = useMemo(() => {
    return !isChecked;
  }, [isChecked]);

  return (
    <S.Dropdown
      value={recommendedPipelineId}
      optionValue="id"
      optionLabel="name"
      options={pipelines}
      placeholder="Select a pipeline"
      onChange={(e) => handleChangePipelineId(idCol, e.target.value)}
      disabled={isDisabled}
      itemTemplate={(d) => (
        <Text fit="space" ellipsis className={`pipeline-list-item-${d?.id}`}>
          {d?.name}
          <PTooltip target={`.pipeline-list-item-${d?.id}`} position="right" content={d?.name} />
        </Text>
      )}
    />
  );
};
